window.createProductionProcessInputElaborationOutput = function(production_process_id){

  $.ajax({
    url: '/factory/production/production_processes/'+production_process_id+'/production_process_inputs',
    type: 'POST',
    data:{
      production_process_input_creation: {
        measure_unit: 'units',
        input_type: 'elaborated_output'
      }
    }
  }).done(function(e) {});
  }
  
  window.updateProductionProcessInputElaborationOutput = function(production_process_id, element_id){
    let product_id = $('#production-process-input-elaboration-output-product-id-'+element_id).val();
    let quantity = $('#production-process-input-elaboration-output-quantity-'+element_id).val();
    let code = $('#production-process-input-elaboration-output-code-'+element_id).val();  

    $.ajax({
      url: '/factory/production/production_processes/'+production_process_id+'/production_process_inputs/'+element_id,
      type: 'PATCH',
      data:{
        production_process_input: {
            product_id: product_id,
            quantity: quantity,
            code: code
        }
      }
    }).done(function(e) {});
  
  }
  
  window.removeProductionProcessInputElaborationOutput = function(production_process_id, element_id){
    $.ajax({
      url: '/factory/production/production_processes/'+production_process_id+'/production_process_inputs/'+element_id,
      type: 'DELETE'
    }).done(function(e) {});
  
  }
  